// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const AttentionExample = zod.object({
  "id": zod.uuid(),
  "label": zod.string()
});

export type AttentionExample = zod.input<typeof AttentionExample>;
export type AttentionExampleOutput = zod.output<typeof AttentionExample>;
